import { combineReducers } from "redux";
import review from "../features/admin/reviewform/review/Slice";




const reviewform = combineReducers({
   review: review,
  
  });
  
  export default reviewform;